import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ListWrap = styled.div`
  margin-top: 20px;
  max-height: 78vh;
  overflow: auto;
  padding-right: 2px;

  @media screen and (min-width: 768px) {
    padding-right: 4px;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(23, 26, 29, 0.15);
  }

  &::-webkit-scrollbar-thumb:hover,
  &::-webkit-scrollbar-thumb:active {
    background: rgba(23, 26, 29, 0.3);
  }
`;

export const Wrap = styled.div`
  position: static;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: auto;
  padding-top: 16px;
  gap: 12px;
  border-top: 1.5px solid rgba(23, 26, 29, 0.1);

  @media screen and (min-width: 768px) {
    padding-top: 20px;
    gap: 16px;
  }
`;

export const Text = styled.p`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-family: ${props => props.theme.fonts.body};
  font-size: 14px;
  color: ${props => props.theme.brand.muted};

  @media screen and (min-width: 768px) {
    font-size: 15px;
  }
`;

export const Total = styled.span`
  font-family: ${props => props.theme.fonts.display};
  font-weight: 700;
  font-size: 20px;
  color: ${props => props.theme.colors.textPrimary};

  @media screen and (min-width: 768px) {
    font-size: 24px;
  }
`;

export const BtnWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;

  @media screen and (min-width: 768px) {
    gap: 14px;
  }
`;

export const Button = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px 12px;
  border: 1.5px solid ${props => props.theme.colors.secondary};
  border-radius: ${props => props.theme.radii.pill};
  font-family: ${props => props.theme.fonts.body};
  font-weight: 600;
  font-size: 12px;
  color: ${props => props.theme.colors.secondary};
  background: transparent;
  cursor: pointer;
  transition: ${props => props.theme.transition.main};

  &:hover,
  &:focus-visible {
    background: ${props => props.theme.colors.secondary};
    color: ${props => props.theme.brand.chalk};
  }

  @media screen and (min-width: 768px) {
    padding: 15px 20px;
    font-size: 15px;
  }
`;

export const StyledLink = styled(Link)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  border-radius: ${props => props.theme.radii.pill};
  font-family: ${props => props.theme.fonts.body};
  font-weight: 600;
  font-size: 12px;
  padding: 10px 12px;
  color: ${props => props.theme.colors.textPrimary};
  background: ${props => props.theme.colors.secondary};
  transition: ${props => props.theme.transition.main};

  &:hover,
  &:focus-visible {
    background: ${props => props.theme.colors.hoverColor};
  }

  @media screen and (min-width: 768px) {
    padding: 15px 20px;
    font-size: 15px;
  }
`;
